import api from './api';

/**
 * Consome os endpoints /api/recompensas do backend do portal (que por sua vez
 * fala com o ledger de saldo do Frotas). Saldo é read-through: sempre lido ao
 * vivo, nunca cacheado para decidir abate.
 */
const rewardsService = {
  // Saldo ao vivo do fornecedor logado (admin pode passar fornecedorId)
  async getSaldo(fornecedorId) {
    const params = fornecedorId ? { fornecedorId } : {};
    const { data } = await api.get('/recompensas/saldo', { params });
    return data; // { ok, disponivel, pendente, elegivelEspecie, notFound, ... }
  },

  // Extrato paginado por cursor
  async getExtrato(cursor, fornecedorId) {
    const params = {};
    if (cursor) params.cursor = cursor;
    if (fornecedorId) params.fornecedorId = fornecedorId;
    const { data } = await api.get('/recompensas/extrato', { params });
    return data; // { ok, entries, nextCursor, hasMore }
  },

  // Quanto dá para abater agora numa fatura de fornecedor
  async previewFatura(faturaId) {
    const { data } = await api.get(`/recompensas/fatura/${faturaId}/preview`);
    return data; // { taxaRestante, valorDevidoAtual, saldo, abatePossivel }
  },

  // Executa o abate na fatura
  async abaterFatura(faturaId) {
    const { data } = await api.post(`/recompensas/fatura/${faturaId}/abater`);
    return data; // { message, abatido, fatura }
  }
};

export default rewardsService;
